import React, { Component } from "react"
import styled from "styled-components"
import colors from "../../styles/colors"
import Slider from "react-slick/lib"
import breakpoints from "../../styles/breakpoints"
import ZoomPopup from "./ZoomPopup"
import { GatsbyImage } from "gatsby-plugin-image"
import { isPackshotImage } from "../../services/images"

const CarouselDots = styled.div`
  position: relative;
  display: flex;
  flex-direction: rows;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (min-width: ${breakpoints.lg}) {
    margin-top: 0;
    position: absolute;
    width: auto;
    top: 50%;
    transform: translateY(-50%);
    bottom: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    left: -55px;
    display: block;
  }
  @media (min-width: ${breakpoints.xl}) {
    left: -60px;
  }
  @media (min-width: ${breakpoints.xxl}) {
    left: -80px;
  }
`

const DotStyled = styled.div`
  z-index: 500;
  height: 14px;
  width: 14px;
  cursor: pointer;
  background: ${(props) =>
    props.$active === true ? `${colors.white}` : "transparent"};
  border-radius: 50px;
  position: relative;
  margin-left: ${(props) => (props.isFirst === "true" ? "0" : "16px")};
  &::before {
    content: "";
    height: 14px;
    width: 14px;
    cursor: pointer;
    border: 1px solid transparent;
    border-color: ${(props) => props.$active === true && `${colors.green}`};
    border-radius: 50px;
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.2s;
    z-index: 100;
  }
  &::after {
    content: "";
    height: 8px;
    width: 8px;
    z-index: 50;
    background: ${(props) =>
      props.$active === true ? `${colors.green}` : "black"};
    opacity: ${(props) => (props.$active === true ? `1` : "0.35")};
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 50px;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: 0.2s;
  }
`

const DotContainer = styled.div`
  padding-bottom: 30px;
  margin-top: -30px;
`

const StyledSlider = styled(Slider)`
  max-height: 410px;
  overflow: hidden;
  .slick-list,
  .slick-track {
    touch-action: pan-y;
  }

  .slick-initialized .slick-slide {
    float: none;
    display: inline-block;
    vertical-align: middle;
  }

  @media (min-width: ${breakpoints.lg}) {
    max-height: 600px;
  }
`

const Slide = styled.div`
  height: 100%;
  width: 100%;
  text-align: right;
  outline: none;
  border: 0;
`

const ProductCarouselImg = styled.div`
  cursor: zoom-in;
  width: 100%;
  height: 100vw;
  max-height: 410px;
  z-index: 1;
  max-width: 100%;
  margin: auto;
  position: relative;
  overflow: hidden;

  video {
    width: 100%;
    min-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    object-fit: cover;
    transform: translate(-50%, -50%);
  }
`

const ProductVideo = styled.video`
  position: relative;
  height: 100%;
`

const ProductImg = styled(GatsbyImage)`
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 410px;
  background: ${colors.white};

  img {
    object-fit: ${(props) => props.objectFit} !important;
  }

  @media (min-width: ${breakpoints.lg}) {
    max-height: 590px;
  }
`

const CarouselContainer = styled.div`
  width: 100%;
  display: block;
  position: relative;
  margin: 0 auto;
`

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  z-index: 888;
  top: 0;
  left: 0;
  position: fixed;
  background: ${colors.white};
  opacity: 0.5;
  display: ${(props) => (props.$isZoomOpen ? "block" : "none")};
`

const ZoomButton = styled.div`
  cursor: pointer;
  position: relative;
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  border-radius: 50px;
  border: 1px solid ${colors.green};
  height: 31px;
  width: 31px;
  color: ${colors.black};
  text-align: center;
  margin-right: 20px;
  margin-top: -55px;
  font-size: 13px;
  transition: 0.5s;

  span {
    height: 29px;
    line-height: 29px;
  }

  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    outline: none;
    box-shadow: none;
    background-color: ${colors.green};
    color: ${colors.white};
    transition: 0.5s;
  }

  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`

const MAX_CAROUSEL_IMAGES = 4;

class ProductGallery extends Component {
  state = {
    slideIndex: 0,
    isZoomOpen: false,
    width: 0,
  }

  constructor(props) {
    super(props)

    this.settings = {
      dots: false,
      arrows: false,
      infinite: true,
      fade: false,
      vertical: true,
      verticalSwiping: false,
      draggable: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 4000,
      initialSlide: 0,
      touchTreshold: 5,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
      responsive: [
        {
          breakpoint: 960,
          settings: {
            dots: false,
            arrows: false,
            infinite: true,
            fade: false,
            vertical: false,
            verticalSwiping: false,
            horizontal: true,
            horizontalSwiping: true,
            draggable: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 4000,
            initialSlide: 0,
          },
        },
      ],
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let mainImageNumber = this.props.mainImageNumber

    if (
      mainImageNumber !== prevProps.mainImageNumber ||
      mainImageNumber === 0
    ) {
      this.changeSlide(mainImageNumber)
    }
  }

  changeSlide(index) {
    this.slider.slickPause()
    this.slider.slickGoTo(index)
  }

  pause() {
    this.slider.slickPause()
  }

  changeSlideIndex(index) {
    this.setState({ slideIndex: index })
  }

  togglePopup(isDesktop = false) {
    if (isDesktop && typeof window !== "undefined") {
      if (window.innerWidth >= 960) {
        this.slider.slickPause()

        this.setState({ isZoomOpen: !this.state.isZoomOpen })
      }
    } else {
      this.slider.slickPause()

      this.setState({ isZoomOpen: !this.state.isZoomOpen })
    }
  }

  componentDidMount = () => {
    if (typeof window !== "undefined") {
      this.updateWindowDimensions()
      window.addEventListener("resize", this.updateWindowDimensions)
      this.containerRef.addEventListener("touchstart", this.touchStart)
      this.containerRef.addEventListener("touchmove", this.preventTouch, {
        passive: false,
      })
    }
  }

  componentWillUnmount = () => {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateWindowDimensions)
      this.containerRef.removeEventListener("touchstart", this.touchStart)
      this.containerRef.removeEventListener("touchmove", this.preventTouch, {passive: false,})
    }
  }

  updateWindowDimensions = () => {
    if (typeof window !== "undefined") {
      this.setState({ width: window.innerWidth })
    }
  }

  touchStart(e) {
    this.firstClientX = e.touches[0].clientX
  }

  preventTouch(e) {
    const minValue = 5 // threshold

    this.clientX = e.touches[0].clientX - this.firstClientX

    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(this.clientX) > minValue) {
      e.preventDefault()
      e.returnValue = false
      return false
    }
  }

  render() {
    const { sliderImages, productName } = this.props
    const { settings, togglePopup } = this
    const { isZoomOpen, slideIndex } = this.state

    return (
      <React.Fragment>
        {sliderImages.length > 0 && (
          <React.Fragment>
            <div id={"carousel"} ref={(el) => (this.containerRef = el)}>
              <CarouselContainer>
                <StyledSlider
                  ref={(slider) => (this.slider = slider)}
                  {...settings}
                >
                  {sliderImages.map((image, index) => {
                    if (index >= MAX_CAROUSEL_IMAGES) return null
                    if (!image) return null
                    return (
                      <Slide key={`image.id ${index}`}>
                        <ProductCarouselImg
                          onClick={togglePopup.bind(this, true)}
                        >
                          {image.altText &&
                            !image.altText.includes("cord-") && (
                              <video
                                src={image.altText}
                                loop
                                muted
                                autoPlay
                                playsInline
                                preload="metadata"
                                aria-label="video"
                              />
                            )}
                          {image?.file?.contentType?.includes("video") ? (
                            <ProductVideo
                              src={image.file.url}
                              loop
                              muted
                              autoPlay
                              playsInline
                              preload="metadata"
                              aria-label="video"
                            />
                          ) : (
                            <ProductImg
                              image={image.gatsbyImageData}
                              objectFit={
                                isPackshotImage(image.src) ? "contain" : "cover"
                              }
                              loading={"eager"}
                              alt={productName || ""}
                            />
                          )}
                        </ProductCarouselImg>
                      </Slide>
                    )
                  })}
                </StyledSlider>
                <ZoomButton onClick={togglePopup.bind(this, false)}>
                  <span>+</span>
                </ZoomButton>
                {sliderImages.length > 1 && (
                  <CarouselDots>
                    {sliderImages.map((slider, index) => {
                      if (index >= MAX_CAROUSEL_IMAGES) return null
                      if (!slider) return null
                      return (
                        <DotContainer key={index}>
                          <DotStyled
                            key={index}
                            $active={this.state.slideIndex === index}
                            onClick={this.changeSlide.bind(this, index)}
                          />
                        </DotContainer>
                      )
                    })}
                  </CarouselDots>
                )}
              </CarouselContainer>
            </div>
            <Overlay $isZoomOpen={isZoomOpen} />
            {isZoomOpen && (
              <ZoomPopup
                sliderImages={sliderImages}
                closePopupFunction={togglePopup.bind(this)}
                initialSlide={slideIndex}
              />
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

export default ProductGallery
